import { type IResponseApiMeta } from 'shared/api'
import { type IFiltersListGroups } from 'entities/Contacts/api/types'
import { type IParamsSendFrom } from 'entities/SendFrom'

export enum SurveysType {
  NPS = 1,
  CSAT = 2,
  XSAT = 3,
  CES = 4,
  PMF = 5,
  Custom = 6,
}

export enum SurveysStatus {
  Draft = 0,
  Active = 1,
  Disabled = 2,
}

export const SurveysFollowUpAssertiveness = {
  Subtle: 'subtle',
  Steady: 'steady',
  Assertive: 'assertive',
} as const

export type ISurveysFollowUpAssertiveness =
  (typeof SurveysFollowUpAssertiveness)[keyof typeof SurveysFollowUpAssertiveness]

export type IParamsCreateSurvey = {
  type: SurveysType
  name: string
  is_active: boolean
  send_from: IParamsSendFrom | null
  filters: IFiltersListGroups | null
  question: {
    company_name: string
  }
  settings: ISurveySettings
}

export type ISurveySettings = {
  allow_re_entering: {
    value: boolean
  }
  score_elaboration_message?: {
    value: string
  }
  score_elaboration_per_group?: {
    value: boolean
  }
  closing_message_value?: {
    value: string
  }
  closing_message_per_group?: {
    value: boolean
  }
  fallback_auto_follow_up_window?: {
    value: number
  }
  fallback_auto_follow_up?: {
    value: boolean
  }
  fallback_end_session?: {
    value: number
  }
  fallback_auto_follow_up_frequency?: {
    value: ISurveysFollowUpAssertiveness
  }
  success_action?: {
    value: boolean
  }
}

export type IResponseGetSurveys = {
  data: IResponseGetSurvey[]
  meta: IResponseApiMeta
}

export type IParamsGetSurveys = {
  page?: number
  limit?: number
  'filters[name]'?: string
}

export type IResponseCreateSurvey = IParamsCreateSurvey & {
  id: number
  status: SurveysStatus
}

export type IResponseGetSurvey = {
  id: number
  name: string
  is_active: boolean
  type: SurveysType
  status: SurveysStatus
  nps_score: number | null
  total_sent: number
  valid_replies: number
  invalid_replies: number
  undelivered: number | null
  expired: number | null
  created_at: string
  updated_at: string
}

export type IResponseFullSurvey = IResponseCreateSurvey & IResponseSurveyDetails

export type IResponseSurveyDetails = {
  total_contacts_count: number
  valid_replies_count: number
  invalid_replies_count: number
  undelivered_count: number
  expired_count: number
  nps_score: number
  promoters_count: number
  promoters_percent: number
  passives_count: number
  passives_percent: number
  detractors_count: number
  detractors_percent: number
}
